import { render, staticRenderFns } from "./GoToBuy.vue?vue&type=template&id=2f259058&scoped=true&"
import script from "./GoToBuy.vue?vue&type=script&lang=js&"
export * from "./GoToBuy.vue?vue&type=script&lang=js&"
import style0 from "./GoToBuy.vue?vue&type=style&index=0&id=2f259058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f259058",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f259058')) {
      api.createRecord('2f259058', component.options)
    } else {
      api.reload('2f259058', component.options)
    }
    module.hot.accept("./GoToBuy.vue?vue&type=template&id=2f259058&scoped=true&", function () {
      api.rerender('2f259058', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/占星小舖/GoToBuy.vue"
export default component.exports